import { format } from 'date-fns/format'
import styled from 'styled-components'

import { DATE_FORMAT } from '@root/shared'

import { PremiumPurchaseTableCurrencyCell } from './premium-purchase-table-currency'
import { PremiumPurchaseTableInvoiceCell } from './premium-purchase-table-invoice-cell'
import { PremiumPurchaseTablePurchaseCell } from './premium-purchase-table-purchase-cell'
import { PremiumPurchaseTableStatusCell } from './premium-purchase-table-status-cell'

import type { PremiumPurchaseTableColumnId } from '../atoms/reatom-premium-purchase-table'
import type { PremiumPurchase } from '@root/entities/premium/model'
import type { Column } from '@root/shared/ui-kit'

export const createPremiumPurchaseTableColumns = (): Array<
  Column<PremiumPurchase.Purchase, PremiumPurchaseTableColumnId>
> => [
  {
    id: 'token',
    header: ({ t }) => t('token'),
    render: ({ value }) => (
      <PremiumPurchaseTableCurrencyCell purchase={value} />
    ),
    minWidth: 120,
  },
  {
    id: 'createdAt',
    header: ({ t }) => t('common.date'),
    render: ({ value }) => <DateText date={value.createdAt} />,
    minWidth: 110,
  },
  {
    id: 'purchase',
    header: ({ t }) => t('premium.feed.purchased-item'),
    render: ({ value }) => (
      <PremiumPurchaseTablePurchaseCell purchase={value} />
    ),
    minWidth: 130,
  },
  {
    id: 'status',
    header: ({ t }) => t('common.status'),
    render: ({ value }) => <PremiumPurchaseTableStatusCell purchase={value} />,
    minWidth: 100,
  },
  {
    id: 'expiresAt',
    header: ({ t }) => t('common.expires'),
    render: ({ value }) => <DateText date={value.expiresAt} />,
    minWidth: 110,
  },
  {
    id: 'invoice',
    header: '',
    render: ({ value }) => <PremiumPurchaseTableInvoiceCell purchase={value} />,
    width: 90,
    justify: 'end',
  },
]

const DateText: React.FC<{ date: Date | undefined }> = ({ date }) => {
  if (!date) {
    return <DateRoot>—</DateRoot>
  }
  return (
    <DateRoot>
      <div>{format(date, DATE_FORMAT.dd_MM_yy)}</div>
      <DateTime>{format(date, DATE_FORMAT.HH_mm)}</DateTime>
    </DateRoot>
  )
}

const DateRoot = styled.div`
  display: grid;
  gap: 2px;
  color: var(--text-11);
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
`

const DateTime = styled.span`
  color: var(--text-7);
  font-size: 10px;
  line-height: 12px;
`
